<template>
  <a-modal v-if="visible" title="Compliance Sheet" :visible="visible" @cancel="closeModal">
    <div class="flex flex-column gap-2">
      <b>Categories</b>
      <a-checkbox-group v-model="categories" :options="plainOptions" />
    </div>

    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="closeModal">Close</a-button>
        <a-button
          :disabled="disabledExport"
          :loading="loadingExport"
          icon="upload"
          type="primary"
          @click="downloadReport"
        >
          Export
        </a-button>
      </div>
    </template></a-modal
  >
</template>

<script>
import util from '@/util'
import { Button, Checkbox, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapState: profileState } = createNamespacedHelpers('profile')
const { mapActions: reportActions } = createNamespacedHelpers('report')

export default {
  components: {
    'a-button': Button,
    'a-checkbox-group': Checkbox.Group
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingExport: false,

      categories: [],
      plainOptions: [
        {
          label: 'Orientation',
          value: 'orientation'
        },
        {
          label: 'Onboarding',
          value: 'onboarding'
        },
        {
          label: 'Trainings',
          value: 'trainings'
        },
        {
          label: 'Company Documents',
          value: 'company_documents'
        },
        {
          label: 'Attached Documents',
          value: 'attached_documents'
        },
        {
          label: 'Departure',
          value: 'departure'
        }
      ]
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    })
  },
  methods: {
    ...reportActions(['generateAssociateDocumentationCompliance']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    closeModal() {
      this.$emit('update:visible', false)
      this.categories = []
    },

    async downloadReport() {
      this.loadingExport = true

      const categoriesMap = this.plainOptions.reduce((acc, curr) => {
        acc[curr.value] = !!this.categories.includes(curr.value)

        return acc
      }, {})

      const payload = {
        associate_id: this.associate.id,
        ...categoriesMap
      }

      try {
        const url = await this.generateAssociateDocumentationCompliance(payload)

        util.downloadFile(url)
      } catch (error) {
        this.showNotification('error', 'Error', error.message || error)
      } finally {
        this.loadingExport = false
      }
    }
  }
}
</script>

<style scoped>
::v-deep .ant-checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
